import { Component, Inject, Injector } from '@angular/core';
import {
    AppVersion,
    AppVersionInstanceToken,
    ConfigConstants,
    CustomInjector,
    DateUtilities,
    detailedVersionString,
    RouterHelperService,
} from '@evorait/pace-core';
import moment from 'moment';
import { ModalTelemetryService, PaceInsightsService } from '@evorait/pace-logging';
import { EnvironmentService } from '@evorait/pace-environment';

@Component({
    selector: 'pace-app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false,
})
export class AppComponent {
    public constructor(
        private readonly injector: Injector,
        private readonly routerHelper: RouterHelperService,
        @Inject(AppVersionInstanceToken) private readonly appVersion: AppVersion,
        private readonly paceInsights: PaceInsightsService,
        private readonly modalTelemetryService: ModalTelemetryService,
        private readonly environmentService: EnvironmentService,
    ) {
        if (this.environmentService.appInsightsConnectionString) {
            this.paceInsights.init(this.environmentService.appInsightsConnectionString);
            this.paceInsights.setAppVersion(detailedVersionString(this.appVersion));
            this.modalTelemetryService.init();
        }
        // find the date format of user's operating system to maintain same format through out the application
        const dateFormatter = new Intl.DateTimeFormat(); // this is a javascript builtin api used to get the date/time format of the user's OS
        const options = dateFormatter.resolvedOptions();
        DateUtilities.setLocale(options.locale || 'en-US');

        // If the language of the device is not defined in the mapped locale set then by default locale 'en' will be set.
        moment.locale(ConfigConstants.enLocale);

        // Make injector statically available for access in domain models, where angular does not provide a DI mechanism
        CustomInjector.setInjector(this.injector);

        this.routerHelper.subscribeToEvents();
    }
}
